import { BaseColumnType } from '@/shared/components/table/typings';

/** 序号配置 */
export const SerialNumberConfig: BaseColumnType = {
  title: '序号',
  width: 80,
  fixed: 'left',
  render: (...args) => args[2] + 1,
};

/** 高德地图的key */
export const amapKey = '2f9f2a1035483ebb82dcca98ee8cb406';
